module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "mine-box-title"
  }, [_vm._v("我的经历")]), _vm._v(" "), _c('div', {
    staticClass: "mine-content"
  }, [(!_vm.loading) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(!_vm.row.cert.status && false) ? _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "is-link": "",
      "title": "我的运动员资质",
      "label": ""
    },
    on: {
      "click": function($event) {
        return _vm.$toast('正在建设中')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "title": "我的教练员资质",
      "label": !_vm.row.cert.status ? '请先进行实名认证' : ''
    },
    on: {
      "click": _vm.toJiaolian
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "title": "我的裁判员资质",
      "label": !_vm.row.cert.status ? '请先进行实名认证' : ''
    },
    on: {
      "click": _vm.toCaipan
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.row.cert.status) ? _c('div', {
    staticClass: "cert-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/cha/bg-yundongyuan.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.$message('正在建设中')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/images/cha/bg-jiaolianyuan.png"),
      "alt": ""
    },
    on: {
      "click": _vm.toJiaolian
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/images/cha/bg-caipanyuan.png"),
      "alt": ""
    },
    on: {
      "click": _vm.toCaipan
    }
  })]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-empty', {
    attrs: {
      "description": "您还未实名认证，请认证后再查询"
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertIndex'
      }),
      expression: "{name: 'CertIndex'}"
    }],
    attrs: {
      "type": "primary",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("立即实名认证\n        ")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f7ae4c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/experience/MyExperience.vue
// module id = 1543
// module chunks = 0